import script from "./SafieDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SafieDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SafieDialog.vue?vue&type=style&index=0&id=1c3400b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3400b4"]])

export default __exports__